<template>
  <sub-page title="修改手机号">
    <div class="form-page">
      <div class="form-group">
        <input v-model.trim="phone" class="line-input" type="tel" maxlength="11" placeholder="请输入新手机号" />
        <div class="code-row">
          <input v-model.trim="code" class="line-input code-input" type="tel" maxlength="6" placeholder="请输入验证码" />
          <span :class="['code-btn', { disabled: counting }]" @click="sendCode">{{ counting ? countdown + 's后重发' : '获取验证码' }}</span>
        </div>
      </div>

      <div class="submit-btn" @click="handleSubmit">确认修改</div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'ChangePhone',
  components: { SubPage },
  data() {
    return {
      phone: '',
      code: '',
      counting: false,
      countdown: 60,
      timer: null
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    sendCode() {
      if (this.counting) return
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$alert('请输入正确的手机号')
        return
      }
      this.counting = true
      this.countdown = 60
      this.$alert('验证码已发送')
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.counting = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    handleSubmit() {
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$alert('请输入正确的手机号')
        return
      }
      if (!/^\d{6}$/.test(this.code)) {
        this.$alert('请输入6位验证码')
        return
      }
      this.$alert('手机号修改成功')
    }
  }
}
</script>

<style scoped>
.form-page {
  min-height: 100%;
  background: #fff;
  padding: 0 calc(60 * var(--w));
}
.form-group {
  padding-top: calc(40 * var(--w));
}
.line-input {
  width: 100%;
  height: calc(140 * var(--w));
  border: none;
  border-bottom: 1px solid #EBEBEB;
  background: transparent;
  font-size: calc(38 * var(--w));
  color: #323233;
  font-family: inherit;
  outline: none;
}
.line-input::placeholder {
  color: #B5B5B5;
}
.code-row {
  display: flex;
  align-items: center;
}
.code-input {
  flex: 1;
  min-width: 0;
}
.code-btn {
  flex-shrink: 0;
  margin-left: calc(24 * var(--w));
  font-size: calc(34 * var(--w));
  color: #2488E8;
  white-space: nowrap;
  cursor: pointer;
}
.code-btn.disabled {
  color: #B5B5B5;
  cursor: default;
}
.submit-btn {
  margin-top: calc(100 * var(--w));
  height: calc(120 * var(--w));
  border-radius: calc(14 * var(--w));
  background: #2488E8;
  color: #fff;
  font-size: calc(44 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.submit-btn:active {
  background: #1E77CE;
}
</style>



// WEBPACK FOOTER //
// src/pages/ChangePhone.vue